import { BellaTranslator } from '@westwing/appshell_types/bellaTranslator';
import { ValidationSchema } from '@westwing/ui-kit/Tools/hooks/useForm/useForm.types';
import isEmail from '@westwing/ui-kit/Tools/Validation/isEmail';
import isEmpty from '@westwing/ui-kit/Tools/Validation/isEmpty';
import isPassword from '@westwing/ui-kit/Tools/Validation/isPassword';

const MIN_PASSWORD_LENGTH = 6;
const PASSWORD_TOO_SHORT_MSG = `attribute too short`;
const INVALID_EMAIL = 'Please enter a valid email address.';
const REQUIRED_FIELD = 'Required field';

const isRequired = (value: string) => !isEmpty(value);

export default (translator: BellaTranslator): ValidationSchema => {
    const applyTrans = (conf: [string, string[]]) => translator(...conf);
    const PasswordAttribute = applyTrans(['Password', []]);
    return {
        email: [
            {
                validate: isRequired,
                message: applyTrans([REQUIRED_FIELD, []]),
            },
            {
                validate: isEmail,
                message: applyTrans([INVALID_EMAIL, []]),
            },
        ],
        password: [
            {
                validate: isRequired,
                message: applyTrans([REQUIRED_FIELD, []]),
            },
            {
                validate: isPassword,
                message: applyTrans([PASSWORD_TOO_SHORT_MSG, [PasswordAttribute, MIN_PASSWORD_LENGTH.toString()]]),
            },
        ],
    };
};
